import { useState } from "react";
import css from "@styled-system/css";
import { Flex, RoundedButton } from "flicket-ui";
import { motion } from "framer-motion";
import { Icon } from "~components";
import { useShopifyCheckout } from "~hooks";
import { CartModal } from "./cartModal";

const Badge = () => {
  const { checkout } = useShopifyCheckout();
  const amount =
    checkout?.lineItems?.edges?.reduce(
      (acc, { node }) => acc + node.quantity,
      0
    ) || 0;
  return (
    <motion.div
      transition={{ type: "spring" }}
      initial={!!amount}
      animate={amount ? "hasValue" : "noValue"}
      variants={{
        hasValue: { scale: 1, opacity: 1 },
        noValue: { scale: 0, opacity: 0 },
      }}
      style={{ position: "absolute", bottom: -8, right: -7 }}
    >
      <Flex
        backgroundColor="error"
        borderRadius="full"
        variant="center"
        color="white"
        minWidth={10}
        px={1}
      >
        {amount}
      </Flex>
    </motion.div>
  );
};

interface ShoppingCartProps {
  type: "primary" | "secondary";
}

export const ShoppingCart = (props: ShoppingCartProps) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <RoundedButton
        position="relative"
        shadow="sm"
        width={40}
        height={40}
        onClick={() => setOpen(true)}
        backgroundColor={
          props.type === "primary" ? "N200" : { _: "P300", md: "N200" }
        }
        css={css({
          svg: {
            color:
              props.type === "primary"
                ? "black"
                : ["white", null, null, null, "black"],
          },
        })}
      >
        <Badge />
        <Icon icon="shopping-cart" fontSize={5} />
      </RoundedButton>
      <CartModal isOpen={open} onClose={() => setOpen(false)} />
    </>
  );
};
